import { InstitucionSnp, ReniecytApi } from '@conacyt/persona-moral-reniecyt-client';
import { AxiosResponse } from 'axios';
import { FiltroPersonaMoral } from '@/shared/model/persona/persona-moral.model';

export default class PersonaMoralService {
  constructor(private reniecytApi: ReniecytApi) {}

  /**
   * Busca una lista de instituciones en Personas Morales por su número de registro o RFC.
   * El filtro 'tipoSolicitud' recibe: Personas Físicas = '2' y Personas Morales = '1'.
   * El filtro de 'sector' recibe: Privado = '1', público = '2' y social = '3'.
   *
   * @param filtroPersonaMoral Filtro para buscar personas morales
   * @param page Número de página de instituciones, inicia en 1
   * @param size Tamaño de la página de instituciones
   * @returns Promesa con una lista de  instituciones SNP
   */
  public findInstituciones(
    filtroPersonaMoral?: FiltroPersonaMoral,
    page?: number,
    size?: number
  ): Promise<AxiosResponse<InstitucionSnp[]>> {
    return new Promise<AxiosResponse<InstitucionSnp[]>>((resolve, reject) => {
      this.reniecytApi
        .getInstitucionSnp(
          filtroPersonaMoral.noDeRegistro,
          filtroPersonaMoral.rfc,
          filtroPersonaMoral.tipoSolicitud,
          filtroPersonaMoral.sector,
          page,
          size
        )
        .then(res => resolve(res))
        .catch(error => reject(error));
    });
  }
}
